(function(window, $, undefined){
    window.JVZoo = window.JVZoo || {};

    window.JVZoo.UILogic = window.JVZoo.UILogic || {};

    window.JVZoo.UILogic.MyAccount = window.JVZoo.UILogic.MyAccount || {};

    window.JVZoo = window.JVZoo || {};

    window.JVZoo.UILogic.MyAccount.calculateAffiliateReferralEarningsNow = function() {
        var $td = $('td#calculateAffiliateReferralsTD');
        var $anchorTag = $('td#calculateAffiliateReferralsTD a');
        var $row = $anchorTag.closest('tr');
        //clean up the pay now link
        if ($anchorTag.length)
        {
            $anchorTag.remove();
        }

        var responseHandlerOptions = {
            URL:'/myaccount/getReferredAffiliateInfo',
            OnHTMLResponse: function(html, responseWrapper, status, xhr) {
              $('.affiliateReferralEarningsPlaceHolder')
                  .replaceWith(
                      '<a name="referredAffiliateDetails"></a>'+html
                  );
            },
            OnDataResponse: function(data, responseWrapper, status, xhr) {

                console.log(data);

                if (data['calculationError'] !== undefined)
                {
                    $td.html(data['calculationError']);
                }
                else
                {
                    $row.after('<tr><td class="text-left td-300"><b>Referred Affiliate Earnings Unpaid:</b></td>' +
                        '<td class="text-left">' + data['unpaidReferredAffiliateTransactionPayout'] + '</td></tr>');

                    $row.after('<tr><td class="text-left td-300"><b>Referred Affiliate Earnings Paid:</b></td>' +
                        '<td class="text-left">' + data['paidReferredAffiliateTransactionPayout'] + '</td></tr>');

                    $row.after(
                        '<tr><td class="text-left td-300"><b>Referred Affiliate Earnings:</b></td>' +
                        '<td class="text-left">' + data['referredAffiliateTransactionPayout']
                        + ' (<a href="/myaccount#referredAffiliateDetails">' + data['referredAffiliateTransactionCount']
                        + ' transactions</a> at $0.10 each)' + '</td></tr>'
                    );
                    $row.remove();
                }
            },
            OnError: function(jqXHR, textStatus, errorThrown) {
            }
        };

        $td.append(
            '<img src="/images/loading-call.gif" title="processing in progress"/>'
        );

        window.JVZoo.Ajax.ExecuteGETResponseWrapper(responseHandlerOptions);
    };
})(window, jQuery);
